import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  StylableButtonDefinition,
  StylableButtonPlatformProps,
  StylableButtonCarmiProps,
} from '../StylableButton.types';

export const props = withCompInfo<
  StylableButtonPlatformProps,
  StylableButtonDefinition,
  StylableButtonCarmiProps
>()(
  ['isQaMode', 'fullNameCompType'],
  ({ isQaMode, fullNameCompType }, carmiData) => {
    return {
      ...carmiData,
      link: carmiData.link && { ...carmiData.link },
      isQaMode,
      fullNameCompType,
    };
  },
);

export default createComponentMapperModel({
  props,
});
